import { ButtonSignal, ButtonType, ControllerButtonMessage, MulticastDelegate1, ROOT_MODEL_UID, TrainingVideoStateChangedMessage, TrainingWearableStateChangedMessage, TrainingWearableStateChangeFailedMessage } from "flavr-common";
import { busService } from "../../bus";
import { TrainingContext } from "../shared/scenarioTypes";
import { OnEnterContactsMessage, OnLeaveContactsMessage } from "../../../messages/selection";
import { AttachmentChangedMessage } from "../../../messages/attachment/AttachmentMessage";
import { Service } from "../../module";
import { ShowModelIndicatorMessage } from "../../../messages/indicator";
import { TrainingObjectStateChangedInternalEvent } from "../scenario/TrainingEvent";
import { determineModelNameForPrinting } from "@modules/model";
export class TrainingUserEventService extends Service {
    constructor() {
        super(busService.connection("TrainingEventService"));
        this.isActive = false;
        /// Input handler methods ///
        this.handleControllerButtonMessage = (message) => {
            var _a;
            const selectHold = message.buttonType === ButtonType.SELECT && message.input === ButtonSignal.HOLD;
            if (!selectHold)
                return;
            if (!this.isActive) {
                console.warn("[training] Cannot handle ControllerButtonMessage because TrainingUserEventService is inactive");
                return;
            }
            const events = (_a = this.eventMap.get("CONTROLLER_ACTION_CLICK")) !== null && _a !== void 0 ? _a : [];
            const triggeredEvents = [];
            for (const event of events) {
                if (event.condition.evaluate(this.context))
                    triggeredEvents.push(event.value);
            }
            for (const event of triggeredEvents) {
                this.onEventTriggeredDelegate.invoke(event);
            }
        };
        this.handleVideoStateChanged = (msg) => {
            var _a;
            if (!this.isActive)
                return;
            const trainingVideoId = msg.trainingVideoId;
            const videoState = msg.newState;
            const objectId = `VIDEO-${trainingVideoId}`;
            this.updatePredefinedTrainingObjectState(objectId, videoState);
            const events = (_a = this.eventMap.get("VIDEO_STATE_CHANGED")) !== null && _a !== void 0 ? _a : [];
            const triggeredEvents = [];
            for (const event of events) {
                if (event.target !== undefined && event.target !== objectId)
                    continue;
                if (event.condition.evaluate(this.context))
                    triggeredEvents.push(event.value);
            }
            for (const event of triggeredEvents) {
                this.onEventTriggeredDelegate.invoke(event);
                console.log(`[training] VideoStateChanged object="${String(trainingVideoId)}" to="${videoState}"`);
            }
        };
        this.handleTrainingWearableStateChangedMessage = (msg) => {
            var _a;
            if (!this.isActive)
                return;
            const trainingWearableId = msg.trainingWearableId;
            const newState = msg.newState;
            const objectId = `WEARABLE-${trainingWearableId}`;
            this.updatePredefinedTrainingObjectState(objectId, newState);
            const events = (_a = this.eventMap.get("WEARABLE_STATE_CHANGED")) !== null && _a !== void 0 ? _a : [];
            const triggeredEvents = [];
            for (const event of events) {
                if (event.target !== undefined && event.target !== objectId)
                    continue;
                if (event.condition.evaluate(this.context))
                    triggeredEvents.push(event.value);
            }
            for (const event of triggeredEvents) {
                this.onEventTriggeredDelegate.invoke(event);
                console.log(`[training] WearableStateChanged object="${String(trainingWearableId)}" to="${newState}"`);
            }
        };
        this.handleTrainingWearableStateChangeFailedMessage = (msg) => {
            var _a;
            if (!this.isActive)
                return;
            const trainingWearableId = msg.trainingWearableId;
            const objectId = `WEARABLE-${trainingWearableId}`;
            const events = (_a = this.eventMap.get("WEARABLE_STATE_CHANGE_FAILED")) !== null && _a !== void 0 ? _a : [];
            const triggeredEvents = [];
            for (const event of events) {
                if (event.target !== undefined && event.target !== objectId)
                    continue;
                if (event.condition.evaluate(this.context))
                    triggeredEvents.push(event.value);
            }
            for (const event of triggeredEvents) {
                this.onEventTriggeredDelegate.invoke(event);
                console.log(`[training] WearableStateChangeFailed object="${String(trainingWearableId)}"`);
            }
        };
        /// Stage changed handler method ///
        this.handleStageChanged = () => {
            var _a;
            const events = (_a = this.eventMap.get("STAGE_CHANGED")) !== null && _a !== void 0 ? _a : [];
            const triggeredEvents = [];
            for (const event of events) {
                if (event.condition.evaluate(this.context))
                    triggeredEvents.push(event.value);
            }
            for (const event of triggeredEvents) {
                this.onEventTriggeredDelegate.invoke(event);
            }
        };
        /// Collision handler methods ///
        this.handleOnEnterContactsMessage = (message) => {
            var _a;
            if (!this.isActive)
                return;
            // Handle all occurred contact events
            const temporarySavedTriggeredTrainingEvents = [];
            for (const contact of message.contacts) {
                const trainingObjectA = this.getTrainingObjectFromContextByUID(contact.collisionShapeAUID);
                const trainingObjectB = this.getTrainingObjectFromContextByUID(contact.collisionShapeBUID);
                if (trainingObjectA === undefined || trainingObjectB === undefined)
                    continue;
                const key = trainingObjectA.id + " | " + trainingObjectB.id;
                const reverseKey = trainingObjectB.id + " | " + trainingObjectA.id;
                let objectCollisionList = this.context.trainingEventMetaInformation.get("OBJECT_COLLISION_LIST");
                if (objectCollisionList === undefined) {
                    objectCollisionList = new Map();
                    this.context.trainingEventMetaInformation.set("OBJECT_COLLISION_LIST", objectCollisionList);
                }
                if (!objectCollisionList.has(key)) {
                    objectCollisionList.set(key, { nameA: trainingObjectA.id, nameB: trainingObjectB.id });
                    objectCollisionList.set(reverseKey, { nameA: trainingObjectB.id, nameB: trainingObjectA.id });
                }
                const events = (_a = this.eventMap.get("OBJECT_COLLISION")) !== null && _a !== void 0 ? _a : [];
                for (const event of events) {
                    if (event.target !== undefined && event.target !== trainingObjectA.id && event.target !== trainingObjectB.id)
                        continue;
                    if (event.condition.evaluate(this.context))
                        temporarySavedTriggeredTrainingEvents.push(event.value);
                }
            }
            for (const triggeredEvent of temporarySavedTriggeredTrainingEvents) {
                this.onEventTriggeredDelegate.invoke(triggeredEvent);
            }
            // Update event icons
            this.updateIcons(this.context);
        };
        this.handleOnLeaveContactsMessage = (message) => {
            var _a;
            if (!this.isActive)
                return;
            // Handle all occurred contact events
            const temporarySavedTriggeredTrainingEvents = [];
            for (const contact of message.contacts) {
                const trainingObjectA = this.getTrainingObjectFromContextByUID(contact.collisionShapeAUID);
                const trainingObjectB = this.getTrainingObjectFromContextByUID(contact.collisionShapeBUID);
                if (trainingObjectA === undefined || trainingObjectB === undefined)
                    continue;
                const key = trainingObjectA.id + " | " + trainingObjectB.id;
                const reverseKey = trainingObjectB.id + " | " + trainingObjectA.id;
                const objectCollisionList = this.context.trainingEventMetaInformation.get("OBJECT_COLLISION_LIST");
                if (objectCollisionList === undefined)
                    continue;
                objectCollisionList.delete(key);
                objectCollisionList.delete(reverseKey);
                const events = (_a = this.eventMap.get("OBJECT_COLLISION")) !== null && _a !== void 0 ? _a : [];
                for (const event of events) {
                    if (event.target !== undefined && event.target !== trainingObjectA.id && event.target !== trainingObjectB.id)
                        continue;
                    if (event.condition.evaluate(this.context))
                        temporarySavedTriggeredTrainingEvents.push(event.value);
                }
            }
            for (const triggeredEvent of temporarySavedTriggeredTrainingEvents) {
                this.onEventTriggeredDelegate.invoke(triggeredEvent);
            }
            // Update event icons
            this.updateIcons(this.context);
        };
        /// Attachment handler methods ///
        // TODO: Right now we can only detect direct child-parent relationships and only when an attachment changed. Ideally
        //  we would like to get the whole model hierarchy and save it in child parent relationships and then use these in the
        //  ObjectIsAncestorOperator to traverse the parent hierarchy from the descendant to the ancestor
        this.handleAttachmentChangedMessage = (message) => {
            var _a;
            const child = this.getTrainingObjectFromContextByUID(message.childUID);
            if (child === undefined) {
                console.warn("[training] Child to attach to parent is undefined. skip");
                return;
            }
            const newParentName = this.determineAttachmentModelName(message.newParentUID);
            let attachmentsMap = this.context.trainingEventMetaInformation.get("ATTACHMENTS_MAP");
            if (attachmentsMap === undefined) {
                attachmentsMap = new Map();
                this.context.trainingEventMetaInformation.set("ATTACHMENTS_MAP", attachmentsMap);
            }
            let attachmentEntry = attachmentsMap.get(child.id);
            if (attachmentEntry === undefined) {
                attachmentEntry = { child: child.id, parent: newParentName };
                attachmentsMap.set(child.id, attachmentEntry);
            }
            else {
                attachmentEntry.parent = newParentName;
            }
            const events = (_a = this.eventMap.get("ATTACHMENT_CHANGED")) !== null && _a !== void 0 ? _a : [];
            for (const event of events) {
                if (event.target !== undefined) {
                    const parentMatches = newParentName !== "DETACHED" && event.target === newParentName;
                    if (event.target !== child.id && !parentMatches)
                        continue;
                }
                if (event.condition.evaluate(this.context))
                    this.onEventTriggeredDelegate.invoke(event.value);
            }
            // Update event icons
            this.updateIcons(this.context);
        };
        this.onEventTriggeredDelegate = new MulticastDelegate1();
        this.eventMap = new Map();
        this.eventIcons = new Set();
        this.context = new TrainingContext();
    }
    init() {
        // Collision events
        this.connection.subscribeByType(ControllerButtonMessage, this.handleControllerButtonMessage);
        this.connection.subscribeByType(OnEnterContactsMessage, this.handleOnEnterContactsMessage);
        this.connection.subscribeByType(OnLeaveContactsMessage, this.handleOnLeaveContactsMessage);
        this.connection.subscribeByType(TrainingVideoStateChangedMessage, this.handleVideoStateChanged);
        this.connection.subscribeByType(TrainingWearableStateChangedMessage, this.handleTrainingWearableStateChangedMessage);
        this.connection.subscribeByType(TrainingWearableStateChangeFailedMessage, this.handleTrainingWearableStateChangeFailedMessage);
        // Attachment events
        this.connection.subscribeByType(AttachmentChangedMessage, this.handleAttachmentChangedMessage);
    }
    updateContext(context) {
        this.context = context;
    }
    updateIcons(context) {
        for (const eventIcon of this.eventIcons.values()) {
            const active = eventIcon.condition.evaluate(context);
            if (active !== eventIcon.active) {
                const targetUID = context.trainingObjectMap.get(eventIcon.targetID);
                if (targetUID === undefined) {
                    console.error(`[training] Target "${eventIcon.targetID}" for icon "${eventIcon.name}" cannot be found`);
                    return;
                }
                this.connection.send(new ShowModelIndicatorMessage(targetUID.modelUid, eventIcon.icon, active, (eventIcon.type === "CONTROLLER_ACTION_CLICK") ? ButtonType.DISCARD : ButtonType.ALL));
                eventIcon.active = active;
            }
        }
    }
    registerEvent(event) {
        // If event has an icon, add it to eventIcons
        const icon = Array.isArray(event.value) ? event.value[0].icon : event.value.icon;
        const id = Array.isArray(event.value) ? event.value[0].id : event.value.id;
        const type = Array.isArray(event.value) ? event.value[0].type : event.value.type;
        if (icon !== undefined) {
            this.eventIcons.add({
                name: id,
                type: type,
                condition: event.condition,
                icon: icon.url,
                targetID: icon.target,
                active: false
            });
        }
        if (Array.isArray(event.value)) {
            for (const singleEvent of event.value) {
                const singleEventCondirional = { condition: event.condition, target: event.target, value: singleEvent };
                this.registerSingleEvent(singleEventCondirional);
            }
        }
        else {
            this.registerSingleEvent(event);
        }
    }
    registerSingleEvent(singleEvent) {
        const events = this.eventMap.get(singleEvent.value.type);
        if (events === undefined) {
            this.eventMap.set(singleEvent.value.type, [singleEvent]);
            return;
        }
        events.push(singleEvent);
    }
    setActive(active) {
        this.isActive = active;
    }
    updateStage() {
        this.handleStageChanged();
    }
    fireObjectStateChangedEvents(objectId) {
        var _a;
        if (!this.isActive)
            return;
        const events = (_a = this.eventMap.get("OBJECT_STATE_CHANGED")) !== null && _a !== void 0 ? _a : [];
        const triggeredEvents = [];
        for (const event of events) {
            if (event.target !== undefined && event.target !== objectId)
                continue;
            if (event.condition.evaluate(this.context))
                triggeredEvents.push(event.value);
        }
        for (const event of triggeredEvents) {
            this.onEventTriggeredDelegate.invoke(event);
        }
    }
    determineAttachmentModelName(attachmentModelUID) {
        if (attachmentModelUID === undefined || attachmentModelUID === ROOT_MODEL_UID)
            return "DETACHED";
        // If we have a training object for this UID then we use its name
        const newParent = this.getTrainingObjectFromContextByUID(attachmentModelUID);
        if (newParent !== undefined)
            return newParent.id;
        console.warn(`[training] Couldn't determine attachment model name for ${determineModelNameForPrinting(attachmentModelUID)}`);
        return "DETACHED";
    }
    /// Other helper methods ///
    getTrainingObjectFromContextByUID(uid) {
        for (const trainingObjectFromMap of this.context.trainingObjectMap.values()) {
            if (trainingObjectFromMap.containsModel(uid)) {
                return trainingObjectFromMap;
            }
        }
        return undefined;
    }
    /// Predefined training event service ///
    updatePredefinedTrainingObjectState(objectID, newStateID) {
        var _a, _b;
        const trainingObject = this.context.trainingObjectMap.get(objectID);
        if (trainingObject === undefined)
            throw new Error(`Couldn't find predefined training object ${objectID}`);
        const nextState = (_a = trainingObject.states) === null || _a === void 0 ? void 0 : _a.find(state => state.name === newStateID);
        if (nextState === undefined)
            throw new Error(`Couldn't find state ${newStateID} of predefined training object ${objectID}`);
        if (((_b = trainingObject.getCurrentState()) === null || _b === void 0 ? void 0 : _b.name) === newStateID)
            return;
        // Set the new state in the state machine
        const allStates = trainingObject.getAllStates();
        for (const state of allStates) {
            if (state.data.name === newStateID) {
                trainingObject.setCurrentState(state);
                break;
            }
        }
        this.onEventTriggeredDelegate.invoke(new TrainingObjectStateChangedInternalEvent(trainingObject, nextState, this.context));
    }
}
